export enum SequenceType {
  Start = 'start',
  Success = 'success',
  Error = 'error',
  Cancel = 'cancel',
  Cached = 'cached',
}
